import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  UIForm,
  UIFormItem,
  UIModal,
  UIModalContent,
  UIModalFooter,
  UIModalHeader,
  UIInput,
} from '@gohighlevel/ghl-ui'

import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CloneTemplateName',
  props: {
  show: { type: Boolean, default: false },
  defaultName: { type: String, default: '' },
},
  emits: ['close:modal', 'clone:template'],
  setup(__props, { emit }) {

const props = __props;


const cloneTemplateName = ref(props.defaultName)

const rules = {
  cloneTemplateName: {
    required: true,
    message: 'Please select a template name',
    trigger: ['input', 'blur'],
    validator() {
      if (!cloneTemplateName.value) return false
      return true
    },
  },
}

const resetFormValue = () => {
  cloneTemplateName.value = ''
}

const handleCancel = () => {
  emit('close:modal')

  resetFormValue()
}
const cloneTemplateForm = ref()
const handleSubmit = () => {
  cloneTemplateForm.value.getForm().validate()
  if (!cloneTemplateName.value) return
  emit('clone:template', cloneTemplateName.value)
  resetFormValue()
}
watch(
  () => props.defaultName,
  val => {
    cloneTemplateName.value = val
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UIModal), {
    show: props.show
  }, {
    header: _withCtx(() => [
      _createVNode(_unref(UIModalHeader), {
        id: "pg-email-builder-modal-clone-template__clone-template-header",
        title: _ctx.$t('emailBuilder.provideTemplateName'),
        onClose: handleCancel
      }, null, 8, ["title"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(UIModalFooter), {
        id: "pg-email-builder-modal-clone-template__clone-new-template-modal-footer",
        negativeText: _ctx.$t('common.cancel'),
        positiveText: _ctx.$t('common.continue'),
        onNegativeClick: handleCancel,
        onPositiveClick: handleSubmit
      }, null, 8, ["negativeText", "positiveText"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(UIModalContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(UIForm), {
            id: "pg-email-builder-modal-clone-template__clone-template-form",
            rules: rules,
            ref_key: "cloneTemplateForm",
            ref: cloneTemplateForm
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UIFormItem), {
                label: _ctx.$t('emailBuilder.provideTemplateName'),
                path: "cloneTemplateName",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UIInput), {
                    id: "pg-email-builder-rss-campaign__rss_feed_url",
                    readonly: false,
                    placeholder: _ctx.$t('emailBuilder.provideTemplateName'),
                    error: false,
                    modelValue: cloneTemplateName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cloneTemplateName).value = $event))
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})